import type { JSX } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Icon, type IconName } from '@/components/ui/icon';

export function TableFooterLink({
  label,
  onClick,
  icon = 'chevron_right',
  className,
}: {
  label: string;
  onClick: () => void;
  icon?: IconName | null;
  className?: string;
}): JSX.Element {
  return (
    <Button
      variant="ghost"
      className={cn(
        'h-11 w-full justify-center gap-2 rounded-none border-t border-[var(--border-subtle)] text-sm font-semibold text-brand-blue-600 hover:bg-neutral-50',
        className
      )}
      onClick={onClick}
    >
      {label}
      {icon ? <Icon name={icon} className="text-base" /> : null}
    </Button>
  );
}
